import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { parseMarkdownToc } from "../lib/toc";

export function PreviewTOC({ markdown, scrollRootRef }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);
  const items = useMemo(() => parseMarkdownToc(markdown), [markdown]);

  if (items.length === 0) return null;

  const handleClick = (e, id) => {
    e.preventDefault();
    const esc =
      typeof CSS !== "undefined" && typeof CSS.escape === "function"
        ? CSS.escape(id)
        : id.replace(/([^\w-])/g, "\\$1");
    const root = scrollRootRef.current ?? document.getElementById("output");
    const el =
      root?.querySelector(`#${esc}`) ?? document.getElementById(id);
    el?.scrollIntoView({ behavior: "smooth", block: "start" });
    window.history.replaceState(null, "", `#${id}`);
  };

  return (
    <nav className="preview-toc no-print" aria-label={t("mdwriter.tocAria")}>
      <button
        type="button"
        className="preview-toc__toggle"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        {t("mdwriter.onThisPage")}
        <span className="preview-toc__count">({items.length})</span>
        <span className="preview-toc__chevron" aria-hidden="true">
          {open ? "▾" : "▸"}
        </span>
      </button>
      {open ? (
        <ol className="preview-toc__list">
          {items.map((item) => (
            <li
              key={`${item.depth}-${item.id}`}
              className={
                item.depth === 3
                  ? "preview-toc__item preview-toc__item--nested"
                  : "preview-toc__item"
              }
            >
              <a
                href={`#${item.id}`}
                className="preview-toc__link"
                onClick={(e) => handleClick(e, item.id)}
              >
                {item.title}
              </a>
            </li>
          ))}
        </ol>
      ) : null}
    </nav>
  );
}
